<div class="login-wrapper">
    <div class="login-card">
        <div class="login-brand">
            <img src="images/logos/sicom.svg" alt="SICOM" />
            <p class="login-brand-org">Conselho Federal de Medicina</p>
            <p class="login-brand-sistema">SICOM</p>
        </div>

        @if (erro()) {
            <p-message severity="error" class="block mb-3">{{ erro() }}</p-message>
            <p-button label="Entrar novamente" styleClass="w-full mt-2" (onClick)="entrarNovamente()" />
        } @else {
            <p class="text-center text-color-secondary my-3">Redirecionando para o login…</p>
        }
    </div>
</div>
